<template>
  <div>
    <div class="toolbar">
      <p class="toolbar-text">
        PLAN ROUTE FOR {{ clientData.name }}
      </p>
      <auto-suggestion-input :header-mode="true" />
    </div>
    <v-btn light flat color="black" @click.stop="$emit('back-to-planner')">
      <v-icon medium>
        keyboard_backspace
      </v-icon>Back to Planner
    </v-btn>
  </div>
</template>

<script>
import AutoSuggestionInput from '../../uiUtils/AutoSuggestionInput.vue'

export default {
  components: { AutoSuggestionInput },

  props: {
    clientData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.toolbar
  width: 100%
  height: 48px
  background-color: $hwayzBlue
  color: white
  display: inline-flex
  justify-content: center !important
  align-items: center !important

.toolbar-text
  text-transform: uppercase
  height: 1px

select
  border-bottom: 1px solid white
  border-radius: 0
  min-width: 200px
</style>
